<template>aa
    <ContactMap
      title="Kontakti"
      :latitude="42.66191"
      :longitude="21.15908"
      :contactCards="contactCards"
    />
  </template>
  
  <script>
  import ContactMap from "@/components/share/ContactPerson.vue";
  
  export default {
    components: { ContactMap },
    data() {
      return {
        contactCards: [
          {
            title: "Sadri Llumnica",
            items: [
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "U.D. Administrator"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "sadri.llumnica@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "038 / 200-18-857"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: ""
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:''
              }
            ]
          },
          {
            title: "Ramize Bejiqi​",
            items: [
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Asistente Administrative"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "ramize.bejiqi@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "038 / 200-18-867"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: ""
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:''
              }
            ]
          }
        ]
      };
    }
  };
  </script>
  